import getLatestMobileAssessment from '../getLatestMobileAssessment';

function formatPatientSubscriptions(subscriptions = []) {
    let patientEducationSubscription = null;
    let patientMessagingSubscription = null;

    const videos = subscriptions.filter(
        (subscription) => subscription.name === 'Pharmacy Videos' && !subscription.unsubscribedOn
    );

    if (videos.length) {
        patientEducationSubscription = { ...videos[0] };
    }
    const assessments = subscriptions.filter((subscription) => subscription.name === 'Mobile Assessments');

    const currentAssessment = assessments.length > 1 ? getLatestMobileAssessment(assessments) : assessments[0];
    if (currentAssessment) {
        patientMessagingSubscription = {
            ...currentAssessment,
            status: !!(currentAssessment.subscribedOn && !currentAssessment.unsubscribedOn),
        };
    }
    return [patientEducationSubscription, patientMessagingSubscription];
}

export default formatPatientSubscriptions;
